import { render, staticRenderFns } from "./ModalSolicitacaoCirurgiaTecnicaRobotica.vue?vue&type=template&id=ce4acc96&scoped=true"
import script from "./ModalSolicitacaoCirurgiaTecnicaRobotica.vue?vue&type=script&lang=ts"
export * from "./ModalSolicitacaoCirurgiaTecnicaRobotica.vue?vue&type=script&lang=ts"
import style0 from "./ModalSolicitacaoCirurgiaTecnicaRobotica.vue?vue&type=style&index=0&id=ce4acc96&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ce4acc96",
  null
  
)

export default component.exports